import { InputHTMLAttributes, PropsWithChildren, forwardRef, useState } from "react";
import { borderClassName, getOutlineColor, roundedClassName, widthClassName } from "./commonClassNames";
import { BorderProps, WidthProp } from "./commonProps";

export type InputFileProps = Omit<InputHTMLAttributes<HTMLInputElement>, "className" | "type"> &
  Pick<BorderProps, "border"> &
  WidthProp;

export const InputFile = forwardRef<HTMLInputElement, PropsWithChildren<InputFileProps>>(
  ({ children, border, width, ...props }, ref) => {
    const [focus, setFocus] = useState(false);

    const containerClassName = [
      "w-fit h-32",
      "bg-white",
      borderClassName({ border }),
      "border-dashed",
      "w-full-important relative",
      roundedClassName({ grouped: false }),
      focus ? `outline-none ring ${getOutlineColor({ border })}` : "",
    ].join(" ");

    const inputClassName = ["absolute h-32 opacity-0", widthClassName({ width })];
    const contentClassName = "grid h-full w-full place-content-center";

    return (
      <div className={containerClassName}>
        <input
          ref={ref}
          className={inputClassName.join(" ")}
          type="file"
          {...props}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
        />
        <div className={contentClassName}>{children}</div>
      </div>
    );
  },
);
